import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

interface Params {
  featureGate: string;
  currentPlan: string;
  targetPlan: string;
  requesterName: string;
  requesterEmail: string;
}

interface ApiResponse {
  success: boolean;
}

const useRequestAdminUpgrade = () => {
  return useMutation<ApiResponse, Error, Params>({
    mutationFn: async (params) => {
      const response = await axios.post<ApiResponse>(
        `${process.env.NEXT_PUBLIC_API_APP_ENDPOINT}/subscription/upgrade/request`,
        params,
      );
      return response.data;
    },
  });
};

export { useRequestAdminUpgrade };
